var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.81 2.77a2.12 2.12 0 0 0-2.22.16 1.4 1.4 0 0 1-.93.3 1.53 1.53 0 0 1-1.07-.42 3.59 3.59 0 0 0-4.52 0 1.586 1.586 0 0 1-2.15 0 3.58 3.58 0 0 0-4.51 0 1.54 1.54 0 0 1-1.08.42 1.34 1.34 0 0 1-.91-.3 2.12 2.12 0 0 0-2.23-.15A2.19 2.19 0 0 0 2 4.74v21.07a2.2 2.2 0 0 0 2.18 2.2h13.34A7.36 7.36 0 0 1 16 23.5a7.5 7.5 0 0 1 7.5-7.5 4 4 0 0 1 .5.03V4.73a2.2 2.2 0 0 0-1.19-1.96M7.6 21.4a1.2 1.2 0 1 1 1.2-1.2 1.2 1.2 0 0 1-1.2 1.2m0-5a1.2 1.2 0 1 1 1.2-1.2 1.2 1.2 0 0 1-1.2 1.2m0-5.2a1.2 1.2 0 1 1 1.2-1.19 1.195 1.195 0 0 1-1.2 1.19m6.4 10h-2.8a1 1 0 0 1 0-2H14a1 1 0 1 1 0 2m4.6-5h-7.4a1 1 0 0 1 0-2h7.4a1 1 0 0 1 0 2m0-5.19h-7.4a1 1 0 0 1 0-2h7.4a1 1 0 0 1 0 2",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 17a6.5 6.5 0 1 0 6.5 6.5 6.51 6.51 0 0 0-6.5-6.5m2.707 5.874-2.666 2.667a1 1 0 0 1-1.415 0l-1.333-1.334a1 1 0 0 1 1.414-1.414l.626.626 1.96-1.96a1 1 0 1 1 1.414 1.415",
    fill: "#ffffff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewInvoice);
export default __webpack_public_path__ + "static/media/new-invoice.32d903a21d03f210480cb6b7fcdc959e.svg";
export { ForwardRef as ReactComponent };